import { MessageDirection } from "../conversation/types";
export const toMessageEvent = (flowEvent) => {
    var _a;
    return {
        id: flowEvent.id,
        type: flowEvent.message ? 'OUTBOUND_MESSAGE' : 'INBOUND_MESSAGE',
        direction: flowEvent.message ? MessageDirection.OUTBOUND : MessageDirection.INBOUND,
        conversationId: flowEvent.conversationId,
        createdAt: flowEvent.createdAt,
        body: (_a = flowEvent.message) !== null && _a !== void 0 ? _a : flowEvent.option,
    };
};
//# sourceMappingURL=index.js.map